import React from "react";
import PropTypes from "prop-types";
import SkeletonList from "../skeletonList";

/**
 * ProductCardSkeleton component for loading states.
 * Displays a skeleton loader that matches the product card structure.
 * Fills its container automatically (h-full w-full)
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className=""] - Additional CSS classes for width and layout.
 * @returns {React.ReactElement} The ProductCardSkeleton component.
 */
const ProductCardSkeleton = ({ className = "" }) => {
  return (
    <div className={`relative flex h-full w-full flex-col ${className}`}>
      {/* Image skeleton - maintains square aspect ratio */}
      <div className="relative w-full" style={{ aspectRatio: "1 / 1" }}>
        <SkeletonList
          count={1}
          className="h-full w-full"
          itemClassName="h-full w-full"
          itemStyle={{
            borderRadius: "8px 8px 0 0",
          }}
        />
      </div>
      {/* Text skeletons below image - fills remaining space */}
      <div className="flex flex-1 flex-col justify-start pt-8 sm:p-12">
        {/* First skeleton */}
        <SkeletonList
          count={1}
          className="mb-4"
          itemClassName=""
          itemStyle={{ width: "236px", height: "12px", borderRadius: "4px" }}
        />
        {/* Second skeleton */}
        <SkeletonList
          count={1}
          className="mb-4"
          itemClassName=""
          itemStyle={{ width: "142px", height: "22px", borderRadius: "4px" }}
        />
        {/* Third skeleton */}
        <SkeletonList
          count={1}
          className="mb-4"
          itemClassName=""
          itemStyle={{ width: "88px", height: "22px", borderRadius: "4px" }}
        />
        {/* Fourth skeleton */}
        <SkeletonList
          count={1}
          className=""
          itemClassName=""
          itemStyle={{ width: "131px", height: "14px", borderRadius: "4px" }}
        />
      </div>
    </div>
  );
};

ProductCardSkeleton.propTypes = {
  className: PropTypes.string,
};

export default ProductCardSkeleton;
